export default __webpack_public_path__ + "images/pensatus-stone-5.svg";